// Open external links in new tabs
document.querySelectorAll('header a, footer a').forEach(link => {
  if (link.hostname !== location.hostname && !link.hostname.endsWith('shopify.com') && !link.href.startsWith('mailto:')) {
    link.target = '_blank';
  }
});

// Credits overlay functionality
document.addEventListener('DOMContentLoaded', () => {
  const link = document.querySelector('.credits-link');
  const overlay = document.querySelector('.credits-overlay');
  const close = document.querySelector('.credits-close');
  if (!link || !overlay || !close) return;

  link.addEventListener('click', e => {
    e.preventDefault();
    overlay.classList.toggle('active');
  });

  close.addEventListener('click', e => {
    e.preventDefault();
    overlay.classList.remove('active');
  });

  document.addEventListener('click', e => {
    if (overlay.classList.contains('active') && !overlay.contains(e.target) && e.target !== link) {
      overlay.classList.remove('active');
    }
  });
});